module.exports = __webpack_public_path__ + "img/blog-2.6c77606e.jpg";